// NPM Imports
import React, { Fragment, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UpgradeBadge, UpgradePopUp } from "../../../../../commonComponents";

// Internal Imports
import { COMMON } from "../../../../../constants";

// Destructuring
const { DOCUMENT_LABELS } = COMMON;

export default function AddCustomDynamicFieldUpgrade(props) {
  const [showPopUp, togglePopUp] = useState(false);

  return (
    <Fragment>
      <div
        className="dynamicfieldcustom-footer"
        data-test="dynamicfieldselect-dynamicfieldcustom-footer">
        <span
          className="dynamicfieldcustom-addcustomfield-wrapper"
          data-test="dynamicfieldselect-dynamicfieldcustom-addcustomfield-wrapper"
          role="button"
          onClick={() => togglePopUp(true)}
          onKeyDown={() => togglePopUp(true)}
          tabIndex="0">
          <span
            className="plusicon"
            data-test="dynamicfieldselect-custom-dynamicfield-plusicon">
            <FontAwesomeIcon icon={["far", "plus"]} className="" />
          </span>
          <div
            className="dynamicfieldcustom-addcustomfield-btn"
            data-test="dynamicfieldselect-dynamicfieldcustom-addcustomfield-btn">
            <div
              className="dynamicfieldcustom-addcustomfield-title"
              data-test="dynamicfieldselect-dynamicfieldcustom-addcustomfield-title">
              Create a custom field <UpgradeBadge />
            </div>
            <div
              className="dynamicfieldselect-note"
              data-test="dynamicfieldselect-dynamicfieldcustom-addcustomfield-description">
              You can create your own{" "}
              {DOCUMENT_LABELS["dynamic-label"].toLowerCase()} field if you do
              not find a relevant one in the standard list above.
            </div>
          </div>
        </span>
      </div>
      {showPopUp && (
        <UpgradePopUp
          featureName={props.featureName}
          onClose={() => togglePopUp(false)}
        />
      )}
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldSelect/AddCustomDynamicField/AddCustomDynamicFieldUpgrade.js